import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { map, Observable } from 'rxjs';
import { MenuItemPublicDto } from '../dtos';
import { MenuItem } from '../models';
import { MenuMapper } from '../mappers';

const API_CMS = `${environment.apiEcommerce}/api/v1/cms`;

@Injectable({
  providedIn: 'root',
})
export class MenuApiService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly menuMapper: MenuMapper = inject(MenuMapper);

  /**
   * Obtener menus transformados a modelos de dominio.
   * @returns Observable<MenuItem[]> - Menús formateados para uso interno
   */
  getMenu(): Observable<MenuItem[]> {
    return this.http
      .get<MenuItemPublicDto[]>(`${API_CMS}/menu`)
      .pipe(map((dtos) => this.menuMapper.mapMenuDtosToMenuItems(dtos)));
  }
}
